import AdminAccessCodesModule from '@/modules/admin-access-codes';

const AdminAccessCodes = () => {
  return <AdminAccessCodesModule />;
};

export default AdminAccessCodes;
